// components/ui/IconButton.tsx
import { type ReactNode } from "react";
import { Link } from "react-router-dom";

interface IconButtonProps {
  to?: string;
  label?: ReactNode;
  children?: ReactNode;
  onClick?: () => void;
  active?: boolean;
  icon?: ReactNode;
  iconPosition?: "top" | "left" | "right" | "bottom";
  className?: string;
  as?: "button" | "link"; // auto-detect based on "to"
}

export default function IconButton({
  to,
  label,
  children,
  onClick,
  active,
  icon,
  iconPosition = "top",
  className = "",
  as,
}: IconButtonProps) {
  const Component = to ? Link : "button";

  return (
    <Component
      to={to as any}
      onClick={onClick}
      className={` w-25 h-22
        flex ${iconPosition === "top" || iconPosition === "bottom" ? "flex-col" : "flex-row"} items-center gap-2 p-2 rounded-md transition
        ${active ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-800 hover:bg-gray-300"}
        dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700
        ${className}
      `}
    >
      {icon && (
        <span className={`h-[20px] shrink-0 ${iconPosition === "top" || iconPosition === "bottom" ? "block" : "inline-block"}`}>
          {icon}
        </span>
      )}

      {/* Label should always show even without icon */}
      {label && <span className="h-5 w-15 text-[12px]">{label}</span>}

      {/* Children content */}
      {children && <span>{children}</span>}
    </Component>
  );
}